import * as React from 'react'
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react'
import { extendTheme } from "@chakra-ui/react"
import { PostHogProvider} from 'posthog-js/react'
import posthog from 'posthog-js'
import {isAdmin} from './script/util';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from './store';


const root = ReactDOM.createRoot(document.getElementById('root'));
const theme = extendTheme({
  styles: {
    global: () => ({
      body: {
        bg: "#fbf7f4",
      },
      colors:{
        white:"#fbf7f4"
      }
    }),
  },
});

const isAdminUser = isAdmin();
const posthogEnabled = !isAdminUser;

if (posthogEnabled) {
  posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
    autocapture: false,
    disable_session_recording: true,
  })
}

root.render(
  <ReduxProvider store={store}>
    <ChakraProvider theme={theme}>
      <React.StrictMode>
        {posthogEnabled ? (
          <PostHogProvider client={posthog}>
            <App posthogEnabled={true} />
          </PostHogProvider>
        ) : (<App posthogEnabled={false} />)
        }
      </React.StrictMode>
    </ChakraProvider>
  </ReduxProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
